var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoIconConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9792 25.748L25.5142 17.5543C25.4188 17.4117 25.2902 17.2945 25.1393 17.2128C24.9885 17.1312 24.82 17.0875 24.6485 17.0857C24.477 17.0838 24.3076 17.1238 24.155 17.2022C24.0025 17.2806 23.8713 17.395 23.7729 17.5355L20.9667 21.5543L19.2292 20.158C19.115 20.0666 18.9831 19.9999 18.8418 19.9622C18.7006 19.9245 18.553 19.9167 18.4085 19.9391C18.264 19.9616 18.1257 20.0139 18.0025 20.0926C17.8793 20.1714 17.7739 20.275 17.6929 20.3968L14.1117 25.7718M16.9229 15.1793C16.9229 16.4737 15.8736 17.523 14.5792 17.523C13.2847 17.523 12.2354 16.4737 12.2354 15.1793C12.2354 13.8848 13.2847 12.8355 14.5792 12.8355C15.8736 12.8355 16.9229 13.8848 16.9229 15.1793ZM8.54166 8.33301C8.04438 8.33301 7.56747 8.53055 7.21584 8.88218C6.86421 9.23381 6.66666 9.71073 6.66666 10.208V28.9005C6.66666 29.3978 6.86421 29.8747 7.21584 30.2263C7.56747 30.578 8.04438 30.7755 8.54166 30.7755H32.9167C33.4139 30.7755 33.8909 30.578 34.2425 30.2263C34.5941 29.8747 34.7917 29.3978 34.7917 28.9005V13.9005C34.7916 13.4115 34.6005 12.9419 34.2592 12.5918L30.6554 8.89801C30.4806 8.71904 30.2718 8.57685 30.0413 8.47982C29.8107 8.38279 29.5631 8.33287 29.3129 8.33301H8.54166Z",
    stroke: "#263238",
    strokeOpacity: 0.16,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIconConnector);
export default __webpack_public_path__ + "static/media/no-icon-connector.76e62a2a83bb79e7cd5b737f8496c6d4.svg";
export { ForwardRef as ReactComponent };